<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <h2>送付先一覧</h2>
      </v-col>
      <v-col
        cols="6"
        md="6"
        sm="6"
        class="text-right"
      >
        <v-btn
          :to="{ name: 'CreateAddress' }"
          class="title-btn red white--text"
        >
          新規登録
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="2"
      >
        <v-text-field
          label="検索"
          dense
          v-model="params.search"
          @change="getAddress"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="2"
      >
        <v-text-field
          label="送付先コード"
          v-model="params.cd"
          dense
          @change="getAddress"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="2"
      >
        <v-text-field
          label="電話番号"
          v-model="params.tel"
          dense
          @change="getAddress"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="3"
      >
        <v-switch
          label="停止中も表示"
          v-model="contain_stopped"
          dense
          @change="getAddress"
        >
        </v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :server-items-length="item_total"
          :loading="loading"
          :options.sync="options"
          :footer-props="footer_props"
          disable-sort
          disable-filtering
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          @update:options="getAddress"
        >
        <template v-slot:item.action="{ item }">
          <v-btn
            small
            color="default"
            :to="{ name: 'EditAddress', params: {id: item.id}}"
          >
            詳細
          </v-btn>
          <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="ml-2"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                dense
                @click="deleteConfirm(item)"
              >
                <v-list-item-title>削除する</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        </v-data-table>
        <confirm-dialog
          ref="confirm"
          title="送付先削除"
          message="送付先を削除してもいいですか？"
          buttonMessage="削除"
          @confirm="deleteAddress"
        >
        </confirm-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    'confirm-dialog': ConfirmDialog,
  },
  data() {
    return {
      headers: [
        {text: "送付先コード", value: "cd"},
        {text: "送付先名称", value: "name_combined"},
        {text: "住所", value: "address_combined"},
        {text: "電話番号", value: "tel"},
        {text: "操作", value: "action", width: "130px"},
      ],
      items: [],
      params: {
        search: '',
        cd: '',
        tel: '',
        is_stopped: false,
      },
      loading: false,
      item_total: 0,
      options: {
        itemsPerPage: 20,
      },
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
      deleteItem: {},
      contain_stopped: false,
    }
  },
  watch: {
    contain_stopped: function() {
      if (this.contain_stopped) {
        this.params.is_stopped = null;
      } else {
        this.params.is_stopped = false;
      }
    }
  },
  methods: {
    async getAddress() {
      this.loading = true;
      try {
        this.params.page = this.options.page;
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/masters/deliveryaddress/`,
          {
            params: this.params,
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            }
          },
        );
        this.item_total = response.data.count
        this.items = response.data.results
        this.loading = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.loading = false;
      }
    },
    deleteConfirm(item) {
      this.deleteItem = item;
      this.$refs.confirm.open();
    },
    async deleteAddress() {
      try {
        await this.$axios.delete(
          `${process.env.VUE_APP_API_URL_BASE}/api/masters/deliveryaddress/${this.deleteItem.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            }
          }
        );
        this.$store.dispatch('setSnackbar', {message: "削除されました", type: "success"});
        await this.getAddress();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "削除できませんでした", type: "error"});
      }
    }
  },
}
</script>